/* eslint-disable no-console */
import { client } from "."; // ← cliente oficial de Supabase

// Suspensión soft (control de acceso): solo toca la columna `habilitado`.
// Aditiva/aislada — NO modificar updateUsuario.js.
export const setUsuarioHabilitado = async (id, habilitado) => {
  const { data, error } = await client.from("usuarios").update({ habilitado }).eq("id", id).select();

  if (error) {
    console.error("Error en setUsuarioHabilitado:", error);
  }

  return { data, error };
};
